<template>
  <!-- #1c5498 on #f8e81c has no design-system token yet; kept as the shipped values until design picks one -->
  <span
    class="inline whitespace-nowrap rounded-xxs bg-[#1c5498] px-1.5 pb-1 pt-0.5 text-center align-baseline text-xs font-medium uppercase leading-none text-[#f8e81c]"
    data-testid="anchor-page-label"
  >Anchor</span>
</template>
